<ng-template #content let-modal>
  <div class="modal-body">
    <div class="row">

      <div class="col-md-12 text-center stillThere">{{ app.text.app.stillThere }}</div>
      <div class="col-md-12 text-center p-3">
        <span>
          <i class="fa-light fa-timer timerIcon"></i>
        </span>
      </div>
    <small class="col-md-12 text-center">{{app.text.app.currentSession}} {{display}}</small>
    </div>
  </div>
  <div class="text-center mb-3">
    <button
      class="btn btnOK m-1"
      (click)="resetTimer()"
    >
      {{ app.text.app.keepLoggedIn }}
    </button>
    <button
      class="btn btnLogout m-1"
      (click)="closeModal()"
    >
      {{ app.text.app.logout }}
    </button>
  </div>
</ng-template>
